import { render, staticRenderFns } from "./UserSettingsOrganizations.vue?vue&type=template&id=57b2fd1a&"
import script from "./UserSettingsOrganizations.vue?vue&type=script&lang=js&"
export * from "./UserSettingsOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports